<template>
  <div class="tournament-single">
    <div class="container">
      <TournamentHeader :tournament="tournament"></TournamentHeader>
      <div class="tournament-content">
        <div class="row">
          <div class="col-md-8 col-12">
            <div class="content" v-html="tournament.about"></div>
          </div>

          <div class="col-md-4 col-12 tournament-sidebar">
            <!-- <b-button v-if="tournament.matches.length" variant="outline-info" block :to="{ name: 'TournamentBracket', params: { id: tournament.slug }}">
              Ver brackets
            </b-button>-->

            <div v-if="tournament.is_payed != undefined && !tournament.is_payed">
              <b-alert variant="success" show>
                <p
                  class="lead"
                >Para esse campeonato estar ativo e publicado você precisa efetuar o pagamento</p>
                <b-btn v-b-modal.paymentModal variant="success">Pagar agora</b-btn>
              </b-alert>

              <b-modal
                id="paymentModal"
                ref="paymentModal"
                header-bg-variant="dark"
                header-text-variant="light"
                :hide-footer="true"
                :hide-header="true"
                size="md"
                body-class="modal-anticheat"
              >
                <b-container fluid>
                  <p class="lead">entre em contato conosco para mais detalhes</p>

                  <p class="lead">whatsapp: +5541992290420</p>

                  <p class="lead">email: queota@queota.club</p>
                </b-container>
              </b-modal>
            </div>

            <div
              v-if="tournament.tournament_teams.map(team => team.approved).length < tournament.slots"
            >
              <h4>Participar</h4>

              <div v-if="!tournament.payments_handled_by_us">
                <a
                  :href="tournament.inscription_url"
                  v-if="tournament.inscription_url"
                  class="btn btn-primary btn-lg btn-block"
                >Inscreva seu time</a>
              </div>

              <b-button
                variant="primary"
                block
                v-b-modal.modalInscription
                v-if="teams.length && tournament.payments_handled_by_us"
              >Quero inscrever meu time</b-button>
              <div v-else>Você deve estar logado e participar de um time aqui no QUEOTA.club</div>
              <b-modal
                @ok="handleInscriptionOk"
                id="modalInscription"
                title="Inscrever time"
                ref="modalInscription"
              >
                <form @submit.stop.prevent="handleInscriptionSubmit">
                  <b-form-group description label="Seu time">
                    <b-form-select v-model="team_id" class="mb-3">
                      <option v-for="team in teams" :key="team.id" :value="team.id">{{team.name}}</option>
                    </b-form-select>
                  </b-form-group>
                </form>
              </b-modal>
            </div>

            <div
              class="team-list"
              v-if="tournament.tournament_teams && tournament.tournament_teams.length"
            >
              <h4>Times inscritos ({{tournament.tournament_teams.length}} de {{tournament.slots}})</h4>
              <div class="team" v-for="team in tournament.tournament_teams" :key="team.slug">
                <TeamCard :team="team.team"></TeamCard>
                <b-badge class="badges" variant="success" v-if="team.payed && team.approved">
                  <i class="fas fa-check"></i>
                  confirmado
                </b-badge>

                <b-badge
                  class="badges"
                  v-else
                  v-b-tooltip.hover
                  title="esse é um processo manual da equipe do QUEOTA.club, basta aguardar"
                >
                  <i class="fas fa-clock"></i>
                  aguardando confirmação
                </b-badge>
              </div>
            </div>
            <div v-else class="no-teams">
              <h5
                v-if="tournament.payments_handled_by_us"
              >nenhum time se registrou ainda. seja o primeiro! :)</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass">
.tournament-single
  .container
    padding-left: 0
    padding-right: 0
    margin-left: 0
    margin-right: 0
    .tournament-content
      background: rgba(255, 255, 255, .02)
      border-left: 1px solid rgba(255, 255, 255, .02)
      border-right: 1px solid rgba(255, 255, 255, .02)
      border-bottom: 1px solid rgba(255, 255, 255, .02)
      border-bottom-left-radius: 4px
      border-bottom-right-radius: 4px
      padding: 20px

      .content
        @media (max-width: 600px)
          img
            width: 100% !important
            height: auto !important

      .tournament-sidebar
        .team-list
          // margin-top: 20px
          // padding-top: 10px
          .team
            position: relative
            .team-card
              max-width: 100%
            .badges
              position: absolute
              bottom: 10px
              right: 10px
        .no-teams
          padding: 20px
          h5
            text-align: center
            color: #666
</style>


<script>
import TournamentHeader from "@/components/TournamentHeader";
import TeamCard from "@/components/TeamCard";
export default {
  name: "TournamentSingle",
  data() {
    return {
      imgCoverDataUrl: "",
      coverShow: false,
      coverParams: {
        name: "cover"
      },
      coverHeaders: {
        Authorization: localStorage.getItem("token")
      },
      coverUploadUrl: `${
        window.location.hostname == "queota.club"
          ? "https://api.queota.club"
          : "http://localhost:5000"
      }/tournaments/${this.$route.params.id}/cover.json`,
      tournament: {
        featured_image: "",
        title: "",
        id: 0,
        cover: {},
        badge: {},
        tournament_teams: [],
        rounds: [],
        matches: []
      },
      team_id: 0,
      teams: []
    };
  },
  metaInfo() {
    return {
      title: `${this.tournament.name}`
    };
  },

  computed: {
    isTournamentAdmin: function() {
      return (
        this.$store.getters.isLoggedIn &&
        this.tournament &&
        this.tournament.tournament_staff &&
        this.tournament.tournament_staff
          .map(i => i.user.id)
          .includes(this.$store.getters.user.id)
      );
    }
  },

  methods: {
    initialize() {
      this.$http
        .get("tournaments/" + this.$route.params.id + ".json")
        .then(response => {
          this.tournament = response.data;
          this.imgCoverDataUrl = response.data.cover.url;
        });

      if (this.$store.getters.isLoggedIn)
        this.$http.get("pages/my_account.json").then(response => {
          if (response.data && response.data.teams)
            this.teams = response.data.teams;
        });
    },

    handleInscriptionSubmit() {
      this.handleInscriptionOk();
    },
    handleInscriptionOk() {
      this.$http
        .get(
          `tournaments/${this.$route.params.id}/join.json?team_id=${
            this.team_id
          }`
        )
        .then(response => {
          this.$notify({
            group: "all",
            title: response.data.message
          });
          this.initialize();
          this.$refs.modalInscription.hide();
        })
        .catch(error => {
          this.$refs.modalInscription.hide();
        });
    }
  },
  mounted() {
    this.initialize();
  },
  watch: {
    "$route.params.id": function(id) {
      this.initialize();
    }
  },
  components: {
    TournamentHeader,
    TeamCard
  }
};
</script>
